import { render, staticRenderFns } from "./UploadSettings.vue?vue&type=template&id=690e04aa&scoped=true"
import script from "./UploadSettings.vue?vue&type=script&lang=js"
export * from "./UploadSettings.vue?vue&type=script&lang=js"
import style0 from "./UploadSettings.vue?vue&type=style&index=0&id=690e04aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e04aa",
  null
  
)

export default component.exports